import styles from './FJSwiper.module.less';
import { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const speed = 80;
let _requestTimer = null;
let tempTimeout = null;
const FJSwiper = props => {
    const { renderItem, list, isOpenSwiper, itemWidth = 328 } = props;

    const swiperRef = useRef(null);
    const containerRef = useRef(null);
    const translateXRef = useRef(0);
    const originSwiperWidthRef = useRef(0);
    const [makeUpNum, setMakeUpNum] = useState(0);
    const isMouseIn = useRef(false);
    const updateSwiperTranslateX = translateX => {
        if (swiperRef.current) {
            swiperRef.current.style.transform = `translateX(-${translateX}px)`;
        }
    };
    useEffect(() => {
        if (isOpenSwiper) {
            if (!isMouseIn.current) {
                play();
            }
        }
    }, [isOpenSwiper, isMouseIn.current]);

    const play = () => {
        if (_requestTimer) {
            window.cancelAnimationFrame(_requestTimer);
            _requestTimer = null;
        }

        if (!isOpenSwiper) {
            return;
        }
        let startTime = null;

        const __play = time => {
            if (!startTime) {
                startTime = time;
            }

            let translateX = translateXRef.current + ((time - startTime) / 1000) * speed;

            if (translateX >= originSwiperWidthRef.current) {
                translateXRef.current = translateX - originSwiperWidthRef.current;
                translateX = translateXRef.current;
                startTime = time;
            }

            _requestTimer = window.requestAnimationFrame(__play);
            updateSwiperTranslateX(translateX);
        };

        _requestTimer = window.requestAnimationFrame(__play);
    };

    const pause = () => {
        if (_requestTimer) {
            window.cancelAnimationFrame(_requestTimer);
            _requestTimer = null;
        }

        try {
            const translate = swiperRef.current.style.transform.replace('translateX(', '');
            const translates = translate.split(',');
            translateXRef.current = Math.abs(parseFloat(translates[0])) || 0;
        } catch (e) {
            translateXRef.current = 0;
        }
    };

    const calculateVisibleItems = () => {
        const containerRect = containerRef.current.getBoundingClientRect();
        const swiperRect = swiperRef.current.getBoundingClientRect();

        originSwiperWidthRef.current = itemWidth * list.length;
        if (containerRect.width < swiperRect.width) {
            const makeUpNum = Math.ceil((containerRect.width / swiperRect.width) * list.length);
            setMakeUpNum(makeUpNum);
            play();
        } else {
            // 不用滚动 居中显示
        }
    };

    useEffect(() => {
        if (list.length) {
            translateXRef.current = 0;
            originSwiperWidthRef.current = 0;
            setMakeUpNum(0);
            tempTimeout = setTimeout(() => {
                calculateVisibleItems();
            }, 300);
        }

        return () => {
            if (tempTimeout) {
                clearTimeout(tempTimeout);
                tempTimeout = null;
            }
            if (_requestTimer) {
                window.cancelAnimationFrame(_requestTimer);
                _requestTimer = null;
            }
        };
    }, [list]);

    const onMouseEnter = () => {
        isMouseIn.current = true;
        pause();
    };

    const onMouseLeave = () => {
        isMouseIn.current = false;
        play();
    };

    const _onClickItem = rect => {
        const containerRect = containerRef.current.getBoundingClientRect();
        let currentTranslateX = 0;
        try {
            const transform = swiperRef.current.style.transform;
            currentTranslateX = Math.abs(parseFloat(transform.match(/translateX\(-?(\d+\.?\d*)px\)/)[1])) || 0;
        } catch (e) {
            currentTranslateX = 0;
        }
        if (rect.left < containerRect.left && rect.left + rect.width > containerRect.left) {
            const scrollDistance = rect.left - containerRect.left;
            const newTranslateX = currentTranslateX - Math.abs(scrollDistance);
            updateSwiperTranslateX(newTranslateX);
        } else if (
            rect.left < containerRect.left + containerRect.width &&
            rect.left + rect.width > containerRect.left + containerRect.width
        ) {
            const scrollDistance = rect.left + rect.width - (containerRect.left + containerRect.width);
            const newTranslateX = currentTranslateX + scrollDistance;
            updateSwiperTranslateX(newTranslateX);
        }
    };

    return (
        <div className={styles.box} ref={containerRef} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div className={styles.swiper} ref={swiperRef}>
                {list.map((item, index) => {
                    return renderItem({ ...item, onClickItem: _onClickItem });
                })}
                {makeUpNum > 0 &&
                    list.slice(0, makeUpNum).map(item => {
                        return renderItem({ ...item, onClickItem: _onClickItem });
                    })}
            </div>
        </div>
    );
};

FJSwiper.propTypes = {
    renderItem: PropTypes.func,
    list: PropTypes.array,
    isOpenSwiper: PropTypes.bool,
};

export default FJSwiper;
